/* eslint-disable max-len */
export default {
  Contact: {
    Title: 'Contact',


    FirstName: {
      Label: 'First Name *',
    },
    LastName: {
      Label: 'Last Name *',
    },
    Email: {
      Label: 'Email Address *',
    },
    PhoneNumber: {
      Label: 'Phone number *',
    },
    StreetAddress: {
      Label: 'Street Address *',
    },
    City: {
      Label: 'City *',
    },
    Province: {
      Label: 'Province/Territory *',
      List: {
        AB: 'Alberta',
        BC: 'British Columbia',
        MB: 'Manitoba',
        NB: 'New Brunswick',
        NL: 'Newfoundland and Labrador',
        NS: 'Nova Scotia',
        NT: 'Northwest Territories',
        NU: 'Nunavut',
        ON: 'Ontario',
        PE: 'Prince Edward Island',
        QC: 'Quebec',
        SK: 'Saskatchewan',
        YT: 'Yukon',
      },
    },
    PostalCode: {
      Label: 'Postal Code *',
    },

    Missing: {
      FullName: 'Name has not been provided yet.',
      Email: 'Email address has not been added yet.',
      PhoneNumber: 'Phone number has not been added yet.',
      Address: 'Mailing address has not been provided yet.',
    },
  },

  Profile: {
    Title: 'Profile',

    ShortBio: 'Short bio',
    PersonalBio: 'Personal bio',
    CaregiverMotivation: 'Caregiver motivation',
    ProfilePhoto: 'Profile photo',
    UploadFile: 'Drop or browser new files',

    Missing: {
      ShortBio: 'Short bio has not been written yet.',
      PersonalBio: 'Personal bio has not been provided yet.',
      CaregiverMotivation: 'Caregiver motivation has not been described yet.',
      ProfilePhoto: 'No profile photo has been uploaded yet.',
    },
  },

  Languages: {
    Title: 'Languages',

    LanguagesOther: {
      Title: 'Language',
      Placeholder: 'e.g., Urdu',
    },
    AddLanguageButton: 'Add Language',
    FluencyHelpText: 'Select the fluency level',
    LanguagesSelectedCount: 'Languages Selected (#{count}):',
    RemoveLanguageButton: 'Remove Language',

    Action: {
      Remove: 'Remove',
      Add: 'Add',
    },

    AvailableLanguages: {
      English: 'English',
      French: 'French',
      Mandarin: 'Mandarin',
      Cantonese: 'Cantonese',
      Hindustani: 'Hindustani',
      Spanish: 'Spanish',
      Punjabi: 'Punjabi',
      Arabic: 'Arabic',
      Tagalog: 'Tagalog',
      Italian: 'Italian',
      German: 'German',
      Portuguese: 'Portuguese',
      Persian: 'Persian',
      Russian: 'Russian',
      Tamil: 'Tamil',
      Vietnamese: 'Vietnamese',
      Gujarati: 'Gujarati',
      Polish: 'Polish',
      Korean: 'Korean',
      SerboCroatian: 'Serbo-Croatian',
      Greek: 'Greek',
      HaitianCreole: 'Haitian Creole',
      Ukrainian: 'Ukrainian',
      Bengali: 'Bengali',
      Romanian: 'Romanian',
      Dutch: 'Dutch',
      Cree: 'Cree',
      Japanese: 'Japanese',
      Hebrew: 'Hebrew',
      Turkish: 'Turkish',
      Malayalam: 'Malayalam',
      Hungarian: 'Hungarian',
      Ilocano: 'Ilocano',
      Somali: 'Somali',
      Swahili: 'Swahili',
      Telugu: 'Telugu',
      Other: 'Other Language',
    },
    Fluency: {
      Basic: 'Basic',
      Conversational: 'Conversational',
      Fluent: 'Fluent',
      Native: 'Native',
    },

    EmptyState: 'No languages have been added yet.',
  },

  Certificate: {
    Title: 'Professional Certifications/Licenses',

    AvailableCertifications: {
      PSW: 'Personal Support Worker (PSW)',
      DSW: 'Developmental Service Worker (DSW)',
      PAB: 'Préposé aux bénéficiaires (PAB)',
      CNA: 'Certified Nursing Assistant (CNA)',
      HCA: 'Health Care Aide (HCA)',
      RNA: 'Registered Nursing Assistant (RNA)',
      RPN: 'Registered Practical Nurse (RPN)',
      RN: 'Registered Nurse (RN)',
      CSW: 'Community Service Worker',
      SSW: 'Social Service Worker',
      CPR: 'CPR Certification',
      FIRST_AID: 'First Aid Certification',
      PSW_STUDENT: 'PSW Student',
      NURSING_STUDENT: 'Nursing Student',
    },

    IssuingOrgOrSchool: {
      Label: 'Issuing Organization/School *',
      Placeholder: 'e.g., George Brown College',
    },

    City: {
      Label: 'City *',
      Placeholder: 'e.g. Toronto',
    },

    DateObtained: {
      Label: 'Date Obtained *',
      Placeholder: 'YYYY-MM',
    },

    EmptyState: 'No certifications have been recorded yet.',

    SelectedCount: 'Certitficates Selected (#{count}):',

    Attachments: 'Attachments',
    HideAttachments: 'Hide attachments',
    ShowAttachments: 'Show attachments',
  },

  WorkHistory: {
    Title: 'Work History',
    Subtitle: 'Tell us about your previous work experience.',
    EmploymentLabel: 'Employment #{number}',
    Employer: {
      Label: 'Employer Name',
      Placeholder: 'Name of the company or organization',
    },
    StartDate: {
      Label: 'Start Date',
      Placeholder: 'YYYY-MM',
    },
    EndDate: {
      Label: 'End Date',
      Placeholder: 'Leave blank if currently employed',
    },
    CanContact: {
      Label: 'This employer can be contacted as a reference',
    },
    ReferenceContactInfo: {
      Label: 'Reference Contact Information',
      Placeholder: 'e.g., Phone: (555) 123-4567, Email: manager@company.com',
    },

    AddEmployerButton: 'Add Employment',

    Summary: {
      Title: 'Employment History Summary (#{count} #{positions}):',
      PositionSingular: 'position',
      PositionPlural: 'positions',
      UnnamedEmployer: 'Unnamed Employer',
      ReferenceAvailable: 'Reference: ',
      DatesNotSpecified: 'Dates not specified',
      UntilDate: 'Until #{date}',
      Present: 'Present',
    },

    EmptyState: 'No employment history has been added yet.',
  },

  VulnerableSectorCheck: {
    Title: 'Vulnerable Sector Check',
    HasCheck: 'Has Vulnerable Sector Check',
    HasBeenVerified: 'Has Been Verified',
    Documents: 'Uploaded Documents',
    EmptyState: 'No documents have been uploaded yet.',
    UploadTitle: 'Upload Supporting Documents',
    UploadDescription: 'Drop files or click to upload the latest vulnerable sector check.',
    HideAttachments: 'Hide attachments',
    ShowAttachments: 'Show attachments',
  },

  CanadianId: {
    Title: 'Canadian ID',
    HasCheck: 'Has Canadian ID',
    HasBeenVerified: 'Has Been Verified',
    Documents: 'Uploaded Documents',
    EmptyState: 'No documents have been uploaded yet.',
    UploadTitle: 'Upload Supporting Documents',
    UploadDescription: 'Drop files or click to upload the latest Canadian ID.',
    HideAttachments: 'Hide attachments',
    ShowAttachments: 'Show attachments',
  },

  Education: {
    Title: 'Education',
    EntryLabel: 'Education #{number}',
    School: {
      Label: 'School',
      Placeholder: 'University or College name',
    },
    FieldOfStudy: {
      Label: 'Field of Study',
      Placeholder: 'Nursing, Personal Support, etc.',
    },
    Degree: {
      Label: 'Degree',
      Placeholder: 'Diploma, Certificate, Bachelor, etc.',
    },
    DateObtained: {
      Label: 'Date Obtained',
      Placeholder: 'Select month and year',
    },
    Documents: 'Uploaded Documents',
    UploadTitle: 'Upload Supporting Documents',
    AddEducationButton: 'Add Education',
    Summary: {
      Title: 'Education summary (#{count} #{entries}):',
      EntrySingular: 'entry',
      EntryPlural: 'entries',
      UnnamedEntry: 'Unnamed Education',
    },
    EmptyState: 'No education details have been added yet.',
    HideAttachments: 'Hide attachments',
    ShowAttachments: 'Show attachments',
  },

  References: {
    Title: 'References',
    ReferenceLabel: 'Reference #{number}',
    Name: {
      Label: 'Reference Name',
      Placeholder: 'Jane Doe',
    },
    Relationship: {
      Label: 'Relationship to reference',
      Placeholder: 'Supervisor',
    },
    Phone: {
      Label: 'Phone',
      Placeholder: '123-456-7890',
    },
    Email: {
      Label: 'Email',
      Placeholder: 'manager@company.com',
    },

    AddReferenceButton: 'Add Reference',

    Summary: {
      Title: 'References summary (#{count} #{references}):',
      ReferenceSingular: 'reference',
      ReferencePlural: 'references',
      UnnamedReference: 'Unnamed Reference',
      ReferenceAvailable: 'Reference: ',
    },

    EmptyState: 'No references have been added yet.',
  },

  PrefsAndAvailability: {
    Title: 'Preferences & Availability',

    Sections: {
      Preferences: 'Preferences',
      Availability: 'Availability',
    },

    Summary: {
      Title: 'Preferences and availability summary:',
    },

    Labels: {
      Preferences: {
        Title: `Preferences`,
        MainTravelMethod: {
          Title: `Main travel method`,
          Options: {
            DRIVE: `Drive`,
            PUBLIC_TRANSPORTATION: `Public transportation`,
            RIDE_SHARE: `Ride share`,
            WALK_OR_BIKE: `Walk or bike`,
          },
        },
        MaxTravelTime: {
          Title: `Max travel time`,
          Options: {
            FIFTEEN_MIN: `15 min`,
            THIRTY_MIN: `30 min`,
            FORTY_FIVE_MIN: `45 min`,
            ONE_HOUR: `1 hour`,
          },
        },
        CatAndDogComfort: {
          Title: `Cat and dog comfort`,
          Options: {
            CATS: `Cats only`,
            DOGS: `Dogs only`,
            BOTH: `Comfortable with both`,
            NONE: `No comfort with either`,
          },
        },
        LengthOfShifts: {
          Title: `Length of shifts`,
          Options: {
            TWO_TO_FOUR_HOURS: `2-4 hours shifts`,
            FOUR_TO_EIGHT_HOURS: `4-8 hours shifts`,
            EIGHT_TO_TWELVE_HOURS: `8-12 hours shifts`,
            OVERNIGHT: `Overnight shifts`,
          },
        },
      },
      Availability: {
        Title: `Availability`,
        ConfirmAvailabilityPreRules: {
          Title: `Confirmed availability pre-rules`,
          Options: {
            true: 'Yes',
            false: 'No',
          },
        },
        ConfirmAvailabilityPostRules: {
          Title: `Confirmed availability post-rules`,
          Options: {
            true: 'Yes',
            false: 'No',
          },
        },
        ConfirmSubmittedAvailability: {
          Title: `Confirmed submitted availability`,
          Options: {
            true: 'Yes',
            false: 'No',
          },
        },
        WorkHoursCapacity: {
          Title: `Work hours capacity`,
          Options: {
            FIVE_TO_TEN_HOURS: `5-10 hours`,
            TEN_TO_TWENTY_HOURS: `10-20 hours`,
            TWENTY_TO_THIRTY_HOURS: `20-30 hours`,
            THIRTY_PLUS_HOURS: `30+ hours`,
          },
        },
        ScheduleTypePref: {
          Title: `Schedule preference`,
          Options: {
            CONSISTENT_WEEKLY_CLIENTS: `Consistent weekly clients`,
            FLEXIBLE_ONE_TIME_SHIFTS: `Flexible one-time shifts`,
            MIX_OF_BOTH: `Mix of both`,
          },
        },
        EarliestStart: {
          Title: `Earliest start`,
          Options: {
            TODAY: `I can work today`,
            ONE_DAY_NOTICE: `1 day notice`,
            THREE_DAY_NOTICE: `3 day notice`,
            ONE_WEEK_NOTICE: `1 week notice`,
          },
        },
        WeeklyAvailability: {
          Options: {
            MORNING: '6 AM - 12 PM',
            AFTERNOON: '12 PM - 6 PM',
            EVENING: '6 PM - 12 AM',
            OVERNIGHT: '12 AM - 6 AM',
          },
        },
        WillHoursChange: {
          Title: `Hours likely to change`,
          Response: {
            Options: {
              NO: `No`,
              YES: `Yes`,
              NOT_SURE_YET: `Not sure yet`,
            },
          },
          Detail: {
            Options: {
              SCHOOL: `School`,
              ANOTHER_JOB: `Another job`,
              FAMILY_OBLIGATIONS: `Family obligations`,
              HEALTH: `Health`,
              OTHER: `Other reasons`,
            },
          },
        },
      },
    },

    DaysOfWeek: {
      Monday: 'Monday',
      Tuesday: 'Tuesday',
      Wednesday: 'Wednesday',
      Thursday: 'Thursday',
      Friday: 'Friday',
      Saturday: 'Saturday',
      Sunday: 'Sunday',
    },

    EmptyState: 'No preferences or availability have been added yet.',
  },

  SkillsAndExp: {
    Title: 'Skills & Experience',

    Summary: {
      Title: 'Skills and experience summary:',
    },

    Labels: {
      MemoryCare: {
        Label: `Memory care`,
        LevelOptions: {
          EarlyStage: `Early stage (forgetfulness, reminders)`,
          MidStage: `Mid stage (confusion, repetition, routine support)`,
          LateStage: `Late stage (behavioural changes, supervision)`,
          NoExperience: `No experience`,
        },
        TaskOptions: {
          RemindersAndOrientation: `Provided reminders and orientation`,
          RedirectedRepetitiveQuestions: `Redirected repetitive questions`,
          SupportedDailyRoutines: `Supported daily routines`,
          ManagedBehaviouralChanges: `Managed behavioural changes`,
          PreventedWandering: `Supervised to prevent wandering`,
          None: `None`,
        },
      },
      MobilitySupport: {
        Label: `Mobility support`,
        LevelOptions: {
          LightSupport: `Light support (steadying, supervision)`,
          ModerateSupport: `Moderate support (walking assistance, transfers)`,
          HighSupport: `High support (wheelchair use, full transfers)`,
          NoExperience: `No experience`,
        },
        TaskOptions: {
          WalkingSupport: `Walking support or standby assistance`,
          Transfers: `Transfers (bed, chair, toilet)`,
          WheelchairAssistance: `Wheelchair assistance`,
          FallPreventionSupport: `Fall prevention support`,
          TwoPersonOrFullTransfers: `Two-Person or full transfers`,
        },
      },
      PersonalCare: {
        Label: `Personal care`,
        LevelOptions: {
          LightCare: `Light care (cueing, setup)`,
          ModerateCare: `Moderate care (hands-on help with some tasks)`,
          FullCare: `Full care (hands-on help with most tasks)`,
          NoExperience: `No experience`,
        },
        TaskOptions: {
          DressingAssistance: `Dressing assistance`,
          BathingOrShowering: `Bathing or showering`,
          ToiletingSupport: `Toileting support`,
          GroomingAndHygiene: `Grooming and hygiene`,
          IncontinenceCare: `Incontinence care`,
        },
      },
      MedicationReminders: {
        Label: `Medication reminders`,
        LevelOptions: {
          RemindersOnly: `Reminders only`,
          AssistanceWithOrganization: `Assistance with organization`,
          OngoingMedicationSupport: `Ongoing medication support as directed`,
          NoExperience: `No experience`,
        },
        TaskOptions: {
          MedicationReminders: `Medication reminders`,
          FillingManagingPill: `Filling or managing pill organizers`,
          FollowMedicationSchedule: `Follow a medication schedule`,
          TrackingMissedRefusedDoses: `Tracking missed or refused doses`,
          ReportingIssues: `Reporting issues to family or care team`,
        },
      },
      MealPreparation: {
        Label: `Meal preparation`,
        LevelOptions: {
          MealPreparationOnly: `Meal preparation only`,
          MealPrepEatingAssist: `Meal prep with eating assistance`,
          FullMealSupport: `Full meal support (including feeding)`,
          NoExperience: `No experience`,
        },
        TaskOptions: {
          PlanningSimpleMeals: `Planning simple meals`,
          CookingMeals: `Cooking meals`,
          AssistingWithEating: `Assisting with eating`,
          FeedingWhenRequired: `Feeding when required`,
          CleaningAfterMeals: `Cleaning up after meals`,
        },
      },
      LightHousekeeping: {
        Label: `Light housekeeping`,
        LevelOptions: {
          OccasionalTidying: `Occasional tidying`,
          RegularLightCleaning: `Regular light cleaning`,
          OngoingHouseholdUpkeep: `Ongoing household upkeep`,
          NoExperience: `No experience`,
        },
        TaskOptions: {
          Laundry: `Laundry`,
          Dishes: `Dishes`,
          SurfaceCleaning: `Surface cleaning`,
          ChangingLinens: `Changing linens`,
          GeneralTidying: `General tidying`,
        },
      },
    },

    Values: {
      NotProvided: 'Not provided',
      Yes: 'Yes',
      No: 'No',
    },

    EmptyState: 'No skills or experience details have been added yet.',
  },

  Personality: {
    Title: 'Personality',

    Summary: {
      Title: 'Personality summary:',
    },

    SummarySection: {
      Title: 'Personality summary',
      Labels: {
        DecisionStyle: 'Decision style',
        CareDrive: 'Care drive',
        Reliability: 'Reliability',
        OverallSummary: 'Overall summary',
      },
    },

    QASection: {
      Title: 'Personality Q&A',
      Actions: {
        Expand: 'View questions and answers',
        Collapse: 'Hide questions and answers',
      },
      Labels: {
        unexpectedShiftFirstAction: {
          Prompt: `If something unexpected happens during a shift, what do you usually do first?`,
          Options: {
            PauseThinkThenAct: `Pause and think, then act`,
            AskForGuidanceFirst: `Ask for guidance first`,
            FollowASimilarRoutine: `Follow a similar routine`,
            CalmThenDecide: `Calm the person, then decide`,
          },
        },
        busyMomentStyle: {
          Prompt: `In a stressful moment how do you usually respond?`,
          Options: {
            StaySteadyAndFocusOnNextSteps: `Stay steady and focus on next steps`,
            SlowDownAndDoubleCheck: `Slow down and double-check`,
            RelyOnRoutines: `Rely on routines`,
            FocusOnEmotionalComfort: `Focus on emotional comfort`,
          },
        },
        carePlanningApproach: {
          Prompt: `When a small decision is needed and no one is available to ask, what feels most like you?`,
          Options: {
            ActIfSafeAndHelpful: `Act if it's safe and helpful`,
            WaitToConfirm: `Wait to confirm`,
            ChooseSafestOption: `Choose the safest option`,
            FollowCarePlanExactly: `Follow the care plan exactly`,
          },
        },
        communicationStyle: {
          Prompt: `Which best describes why you work in caregiving?`,
          Options: {
            BuildLongTermTrust: `Build long-term trust`,
            HelpWithDailyNeeds: `Help with daily needs`,
            MeaningfulWorkThatFitsMyLife: `Meaningful work that fits my life`,
            SupportPeopleThroughHardTimes: `Support people through hard times`,
          },
        },
        newClientFirstShift: {
          Prompt: `If you finish tasks early, what do you usually do?`,
          Options: {
            LookForSafeWaysToHelp: `Look for safe ways to help`,
            AskWhatElseIsNeeded: `Ask what else is needed`,
            StayAvailable: `Stay available`,
            WaitForNextTask: `Wait for next task`,
          },
        },
        feedbackResponse: {
          Prompt: `If you notice a small change in routine or mood, what do you do?`,
          Options: {
            AdjustAndMentionLater: `Adjust and mention later`,
            MessageYourManager: `Message your manager`,
            WatchToSeeIfItContinues: `Watch to see if it continues`,
            StickToThePlan: `Stick to the plan`,
          },
        },
        energyDuringLongShift: {
          Prompt: `If you can't do something as planned, what do you do?`,
          Options: {
            TellTheTeamRightAway: `Tell the team right away`,
            AskForGuidance: `Ask for guidance`,
            MakeASmallAdjustment: `Make a small adjustment`,
            TryToStickToThePlan: `Try to stick to the plan`,
          },
        },
        conflictApproach: {
          Prompt: `Before accepting a shift, what do you usually do?`,
          Options: {
            CheckScheduleCarefully: `Check schedule carefully`,
            AssumeICanAdjust: `Assume I can adjust`,
            AcceptReviewLater: `Accept, review later`,
            AcceptIfItFitsMostDays: `Accept if it fits most days`,
          },
        },
        preferredWorkRhythm: {
          Prompt: `If your availability might change, when do you communicate it?`,
          Options: {
            AsSoonAsImAware: `As soon as I'm aware`,
            OnceConfirmed: `Once confirmed`,
            ADayOrTwoBefore: `A day or two before`,
            OnlyIfItAffectsTheShift: `Only if it affects the shift`,
          },
        },
        whatFamiliesNoticeMost: {
          Prompt: `If you might be late or unavailable for a shift, what do you do?`,
          Options: {
            MessageYourManagerImmediately: `Message your manager immediately`,
            WaitUntilSure: `Wait until sure`,
            TryToManageQuietly: `Try to manage quietly`,
            HopeItResolves: `Hope it resolves`,
          },
        },
      },
    },

    EmptyState: 'Personality form has not been filled.',
  },

  Agreement: {
    Title: 'Agreements & Declarations',
    Subtitle: 'Please review each statement below and confirm the items that apply to you.',
    Questions: {
      TermsAgreement: {
        Title: 'I agree to the platform terms and conditions',
        Subtitle: 'I have reviewed the caregiver platform terms of service and privacy policy and I accept them.',
      },
      CertifiesTruthfulness: {
        Title: 'I certify that the information I have provided is truthful',
        Subtitle: 'All details submitted in my application are accurate to the best of my knowledge.',
      },
      UnderstandsPrivacyAndAgreesToConfidentialityPolicies: {
        Title: 'I understand and will uphold privacy and confidentiality policies',
        Subtitle: 'I agree to protect client information and comply with all confidentiality requirements.',
      },
      CertifiesValidAndUpToDateCertifications: {
        Title: 'My licences and certifications are valid and up to date',
        Subtitle: 'Every qualification or certificate I have listed remains current and can be verified.',
      },
      UnderstandsAbuseProhibition: {
        Title: 'I understand that abuse, neglect, or exploitation is strictly prohibited',
        Subtitle: 'I acknowledge that any abusive behaviour toward clients is forbidden and grounds for removal.',
      },
      CommittedToCodeOfConductAndEthics: {
        Title: 'I commit to following the organization\'s code of conduct and ethics',
        Subtitle: 'I will uphold our standards in every interaction with clients, families, and fellow team members.',
      },
    },
    Summary: {
      Confirmed: 'Confirmed',
      Pending: 'Pending confirmation',
    },
    EmptyState: 'No agreement responses have been recorded yet.',
  },
};


